import { type ChangeEvent, type HTMLProps } from "react";
import { twMerge } from "tailwind-merge";
import styles from "./checkbox.module.css";

export type CheckboxProps = Omit<HTMLProps<HTMLInputElement>, "onChange"> & {
  checked: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  ariaLabel?: string;
  indeterminate?: boolean;
};

export const Checkbox = ({
  ariaLabel,
  checked,
  className,
  indeterminate,
  ...props
}: CheckboxProps) => {
  return (
    <input
      type="checkbox"
      aria-label={ariaLabel}
      checked={checked}
      className={twMerge(
        styles.checkbox,
        "border-grey-300 ring-primary-100 checked:border-primary-600 checked:bg-primary-50 hover:border-primary-600 hover:bg-primary-100 disabled:border-grey-300 disabled:bg-grey-100 [&:not(:checked,:hover):focus-visible]:border-primary-300 relative m-0 grid h-5 w-5 shrink-0 cursor-pointer appearance-none place-content-center rounded-[6px] border bg-white outline-hidden transition-all duration-100 focus-visible:ring-4 disabled:cursor-not-allowed",
        className,
        indeterminate === true
          ? `${styles.indeterminate ?? ""} indeterminate`
          : "",
      )}
      {...props}
    />
  );
};
